var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-button-square-container",style:(`
    ${_vm.items_per_row
      ? `width: calc((100% - ${(_vm.items_per_row - 1) * 8}px) / ${_vm.items_per_row});`
      : ''
    }
    ${!_vm.items_per_row && _vm.width
      ? `width: ${_vm.width}px;
        height: ${_vm.width}px`
      : ''
    }`)},[(_vm.is_badge)?_c('div',{staticClass:"radio-button-square-badge",style:(`
      color:${_vm.getColor(_vm.foreground_color)};
      background-color:${_vm.getColor(_vm.background_color)};
      ${_vm.badge_width
        ? `height: ${_vm.badge_width}px;
          width: ${_vm.badge_width}px;
          top: -${_vm.badge_width / 4}px;
          right: -${_vm.badge_width / 4}px;
          border-radius: ${_vm.badge_width / 2}px;`
        : ''
      }`)},[_vm._t("badge")],2):_vm._e(),(_vm.items_per_row)?_c('div',{staticClass:"radio-button-square-dummy-height"}):_vm._e(),(!_vm.is_invisible)?_c('button',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"radio-button-square-border",style:(`
      ${_vm.items_per_row ? 'position: absolute; top: 0px; left: 0px;' : ''}
      border-color: ${_vm.getColor(_vm.foreground_color)};
      color:${_vm.is_active ? `${_vm.getColor(_vm.background_color)}` : `${_vm.getColor(_vm.foreground_color)}`};
      fill:${_vm.is_active ? `${_vm.getColor(_vm.background_color)}` : `${_vm.getColor(_vm.foreground_color)}`};
      opacity:${_vm.is_disabled ? '.33' : '1'};
      background-color:${_vm.is_active ? `${_vm.getColor(_vm.foreground_color)}` : ''};
      `),attrs:{"disabled":_vm.is_disabled},on:{"click":function($event){return _vm.$emit('setActive', _vm.id);}}},[_vm._t("content")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }